import axiosInstance from "api/axiosInstance";
import showToast from "./../../../toast/ToastProvider";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const registerUser = async (userData) => {
  try {
    const response = await axiosInstance.post(`/auth/register`, userData);
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
      /*
      if (status == 409) {
        console.warn("خطای 409: این یوزر قبلا ایجاد شده است.");
        toast.error(" این اکانت قبلا ایجاد شده است.");
        setTimeout(() => {
          window.location.href = "/login";
        }, 2000);
        return;
      }
      */
    }
  }
};

export const loginUser = async (payload) => {
  try {
    const response = await axiosInstance.post("/auth/login", {
      ...payload
    });

    return response.data;
  } catch (error) {
    console.log("خطا در ورود:", error);
    console.log(error.response, "error.response");
    if (error.response) {
      const status = error.response.status;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
      /*
      if (status === 404) {
        toast.error("کاربر یافت نشد، لطفاً ابتدا ثبت‌نام کنید.");
      } else if (status === 403) {
        // پیامی که از سرور دریافت شده
        toast.error("نام کاربری یا رمز عبور اشتباه است.");
      } else {
        toast.error("مشکلی در ورود پیش آمد، لطفاً دوباره تلاش کنید.");
      }
      */
    } else {
      // خطاهای مربوط به شبکه یا سرور
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
  }
};


export const otpReq = async (payload) => {

  try {
    const response = await axiosInstance.post("/auth/otp/request", {
      ...payload
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.data;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
      return status;
    } else {
      // خطاهای مربوط به شبکه یا سرور
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
      return {
        ok: false,
        error: {
          message: "مشکل شبکه یا عدم دسترسی به سرور."
        }
      }
    }
  }
};
export const otpVerify = async (payload) => {
  try {


    const response = await axiosInstance.post("/auth/otp/verify", {
      ...payload
    });

    return response.data;
  } catch (error) {

    if (error.response) {
      const status = error.response.status;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");

    } else {
      // خطاهای مربوط به شبکه یا سرور
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
  }
}

export const resetPassword = async (payload) => {
  try {


    const response = await axiosInstance.post("/auth/reset-password", {
      ...payload
    });

    return response.data;
  } catch (error) {

    if (error.response) {
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");

    } else {
      // خطاهای مربوط به شبکه یا سرور
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
  }
}

export const getUserProfile = async () => {
  try {
    const response = await axiosInstance.get("/user/@me");
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
      /*
      if (status === 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = "/login";
        return;
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
      };
      */
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};

export const changePassword = async ({
  accessToken,
  oldPassword,
  password,
  confirmPassword,
}) => {
  try {
    const response = await axiosInstance.post(
      "/auth/password",
      { oldPassword, password, confirmPassword },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const errorMessage = error.response.data?.error || error?.message;
      if (errorMessage) toast.error(errorMessage);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
      /*
      if (status === 400) {
        toast.error("رمز عبور جدید و تکرار رمز عبور یکسان نیستند.");
      } else if (status === 403) {
        console.log(error.response.data?.error);
        error.response.data?.error == "Invalid Token, please login again."
          ? (window.location.href = "/login")
          : toast.error("رمز عبور اشتباه است.");
      } else {
        toast.error(
          errorMessage ||
            "مشکلی در تغییر رمز عبور پیش آمد، لطفاً دوباره تلاش کنید."
        );
      }
      */
    } else {
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }
    return null; // مقدار مناسب برگردانده شود تا در سایر قسمت‌های برنامه قابل بررسی باشد
  }
};
